import React from 'react';
import FilterToggles from '@/components/buttons/FilterToggles';
import { roleGroupings } from '../constants';

const RolesFilterToggles = ({ userFlag, tokenFlag, updateFlags }) => (
  <FilterToggles filters={[
    {
      active: userFlag,
      icon: 'users',
      key: 'roles_users',
      messageId: `roles.grouping.filter.${roleGroupings.USERS}`,
      onClick: () => updateFlags(!userFlag, tokenFlag),
    },
    {
      active: tokenFlag,
      icon: 'code',
      key: 'roles_tokens',
      messageId: `roles.grouping.filter.${roleGroupings.TOKENS}`,
      onClick: () => updateFlags(userFlag, !tokenFlag),
    },
  ]}
  />
);

export default RolesFilterToggles;
